const Scroller = ({
  selector = '[data-scroll-el]',
  scrollBehavior = 'auto',
}) => {
  const clickHandler = (event) => {
    event.preventDefault();
    const { currentTarget } = event;
    const el = document.getElementById(currentTarget.dataset.target);

    if (el) {
      el.scrollIntoView({ behavior: scrollBehavior });
    }
  };

  const els = document.querySelectorAll(selector);

  for (let i = 0; i < els.length; i += 1) {
    const el = els[i];

    el.addEventListener('click', clickHandler);
  }
};

export default Scroller;
